export const OsteotomyTypes = {
  GRADE_1_PCO: "GRADE I",
  GRADE_2_PCO: "GRADE II",
  GRADE_3_PSO: "GRADE III",
  GRADE_4_PSO: "GRADE IV",
};

export const isPCOType = osteotomyType => {
  return (
    osteotomyType === OsteotomyTypes.GRADE_1_PCO ||
    osteotomyType === OsteotomyTypes.GRADE_2_PCO
  );
};

export const SegementalTransformationTypes = {
  SINGLE: "single",
  FULL: "full",
};

export const TranslationDirections = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

export const ActNatures = {
  Osteotomy: "osteotomy",
  SegmentalTransformation: "segmentalTransformation",
  Cage: "cage",
  GlobalAlignment: "globalAlignment",
  Rod: "rod",
  ReciprocalChange: "reciprocalChange",
};

export const SurgerySidebarCategories = {
  spp: "spp",
  history: "history",
};

export const SpineRigidityType = {
  RIGID: "Rigid",
  STIFF: "Stiff",
  FLEXIBLE: "Flexible",
};
